import { Theme } from '@mui/material/styles'

const muiAutoComplete = (theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        '& .MuiOutlinedInput-root': {
          padding: '0.25rem 0.5rem',
          background: theme.palette.background.paper
        }
      },
      popupIndicator: {
        height: '1.75rem',
        width: '1.75rem',
        '& .MuiSvgIcon-root ': {
          height: '1.25rem',
          width: '1.25rem'
        }
      },
      endAdornment: {
        top: '50%',
        transform: 'translateY(-50%)',
        right: '1.875rem'
      },
      clearIndicator: {
        height: '1.875rem',
        width: '1.875rem'
      },
      listbox: {
        padding: 0,
        '& .MuiAutocomplete-option': {
          padding: '0.75rem'
        }
      },
      option: {
        '&.Mui-focused': {
          background: theme.colors.default,
          color: theme.palette.text.secondary
        }
      }
    }
  }
}

export default muiAutoComplete
